export default function antiShake(callback, t) {
  let time = null;
  return function () {
    if (time) {
      clearTimeout(time);
    }
    time = setTimeout(() => {
      callback && callback();
    }, t);
  };
}
